import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators, ActionCreatorsMapObject } from 'redux';
import * as actionCreators from '../actions/actionCreators';

// This cast is still needed — NOT for the tree action-type constants (those moved
// to constants/treeActions), but for the thunks. Most exports are thunk action
// creators `(...args) => (dispatch, getState) => Promise<...>`; with precise types,
// bindActionCreators hands back the raw thunk, so `actions.foo(...).then(...)` and
// the app's loose call sites don't type-check. Casting to ActionCreatorsMapObject
// makes every action `(...args: any[]) => any`. Dropping it needs the whole thunk
// layer typed against redux-thunk — a separate, larger migration.
const creators = actionCreators as unknown as ActionCreatorsMapObject;

// Returns the app's action creators bound to dispatch — the hooks equivalent of
// the old `actions: bindActionCreators(actionCreators, dispatch)` in
// mapDispatchToProps. Lets converted components keep calling `actions.foo(...)`.
// Memoised on dispatch (which is stable), so the bound object is created once.
export function useActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(creators, dispatch), [dispatch]);
}

export default useActions;
